function buocQuanLyHopTacXa() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Hợp tác xã",
      content:
        "Mỗi HTX có Mã HTX định danh dạng HTX-{mã tỉnh}-{mã xã}-{STT}, sinh tự động đúng 1 lần lúc tạo mới. Sửa lại Tỉnh/Xã của một HTX đã có mã KHÔNG sinh lại mã — mã cũ giữ nguyên vĩnh viễn để khớp chứng từ đã in.",
    },
    {
      target: "#tour-quan-ly-hop-tac-xa-nut-them",
      title: "Bước 2 · Thêm hợp tác xã",
      content:
        "Bấm để mở form thêm hợp tác xã mới — nhập Tên hợp tác xã và chọn Tỉnh/Xã, hệ thống tự sinh Mã HTX ngay sau khi lưu (chỉ sinh một lần lúc tạo).",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-hop-tac-xa-xuat-excel",
      title: "Bước 3 · Xuất Excel",
      content: "Xuất đúng danh sách hợp tác xã đang hiển thị (theo bộ lọc tìm kiếm) ra file Excel.",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-hop-tac-xa-tim",
      title: "Bước 4 · Tìm nhanh",
      content: "Tìm theo Mã HTX, tên, người đại diện, số điện thoại hoặc email.",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-hop-tac-xa-danh-sach",
      title: "Bước 5 · Cấp mã cho HTX cũ",
      content:
        'HTX được tạo TRƯỚC khi có tính năng Mã HTX sẽ chưa có mã sẵn — mỗi dòng như vậy có nút "Cấp mã" riêng, chỉ bấm được sau khi đã bổ sung đủ Tỉnh/Xã qua nút Sửa. Nút Sửa/Xoá của từng HTX cũng nằm ngay trên mỗi dòng trong bảng này.',
      placement: "top",
    },
  ];
}

export default buocQuanLyHopTacXa;
